module.exports = __webpack_public_path__ + "img/MapThumb_Wetlands.a0bb353e.webp";